(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    class HeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll(':scope > .hero__slide'));
        this.delay = (parseFloat(this.dataset.speed) || 5) * 1000;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onBreakpointChange = () => this.ensureVisibleActive();
        this.onVisibilityChange = () => (document.hidden ? this.stop() : this.start());
        this.mobileQuery.addEventListener('change', this.onBreakpointChange);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.ensureVisibleActive();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.mobileQuery.removeEventListener('change', this.onBreakpointChange);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      visibleSlides() {
        return this.slides.filter((slide) =>
          Array.from(slide.children).some((child) => getComputedStyle(child).display !== 'none')
        );
      }

      setActive(activeSlide) {
        this.slides.forEach((slide) => {
          slide.classList.toggle('is-active', slide === activeSlide);
          slide.setAttribute('aria-hidden', String(slide !== activeSlide));
        });
      }

      ensureVisibleActive() {
        const visible = this.visibleSlides();
        const current = this.slides.find((slide) => slide.classList.contains('is-active'));
        this.setActive(visible.includes(current) ? current : visible[0]);
      }

      next() {
        const visible = this.visibleSlides();
        if (visible.length < 2) return;
        const index = visible.findIndex((slide) => slide.classList.contains('is-active'));
        this.setActive(visible[(index + 1) % visible.length]);
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.next(), this.delay);
      }

      stop() {
        clearInterval(this.timer);
      }
    }

    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
